import { GEOLOCATION_API } from "src/constants";
import { APIGeolocation } from "./geoLocalization.d";

export const retrieveGeoLocation = async (): Promise<APIGeolocation> => {
  const response = await fetch(GEOLOCATION_API);
  const { city, country, country_name, latitude, longitude } =
    (await response.json()) as APIGeolocation;
  return { city, country, country_name, latitude, longitude };
};
